import { NAME_MAX } from '@accra/shared';
import { el } from '../components/el';

/**
 * "Playing as Kofi · CHANGE" row. Change opens an inline box; Save calls `rename`,
 * which resolves to an error message or null on success.
 */
export class NameEditor {
  readonly root = el('div', 'name-editor');
  private readonly label = el('span', 'name-current');
  private readonly change = el('button', 'name-change', 'Change');
  private readonly form = el('form', 'name-edit');
  private readonly input = el('input', 'name-input');
  private readonly message = el('small', 'name-message');
  private name: string | null = null;

  constructor(private readonly rename: (name: string) => Promise<string | null>, private readonly onRenamed: (name: string) => void) {
    this.input.maxLength = NAME_MAX;
    this.input.placeholder = 'e.g. Kofi from Madina';
    const save = el('button', 'btn small', 'Save');
    const cancel = el('button', 'btn small', 'Cancel');
    cancel.type = 'button';
    cancel.addEventListener('click', () => this.close());
    this.form.append(this.input, save, cancel);
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      void this.save();
    });
    this.change.addEventListener('click', () => this.open());
    const row = el('div', 'name-row');
    row.append(this.label, this.change);
    this.root.append(row, this.form, this.message);
    this.close();
  }

  show(name: string | null): void {
    this.name = name;
    this.label.replaceChildren(el('small', '', 'Playing as'), el('b', '', name ?? 'No name yet'));
    this.change.textContent = name ? 'Change' : 'Set name';
    this.message.textContent = '';
    this.close();
  }

  private open(): void {
    this.form.style.display = '';
    this.change.style.display = 'none';
    this.input.value = this.name ?? '';
    this.input.focus();
    this.input.select();
  }

  private close(): void {
    this.form.style.display = 'none';
    this.change.style.display = '';
  }

  private async save(): Promise<void> {
    const name = this.input.value.trim();
    if (name === this.name) return this.close();
    if (name.length < 2) {
      this.message.textContent = 'At least 2 letters.';
      return;
    }
    this.message.textContent = 'Saving…';
    const error = await this.rename(name);
    if (error) {
      this.message.textContent = error;
      return;
    }
    this.show(name);
    this.message.textContent = `You're now ${name} on the board.`;
    this.onRenamed(name);
  }
}
